import { queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"

export const companyKycKey = (companyId: number) =>
	["companies", companyId, "kyc"] as const

export function companyKycOptions(companyId: number) {
	return queryOptions({
		queryKey: companyKycKey(companyId),
		queryFn: () =>
			GET("/api/v1/companies/{company_id}/kyc", {
				params: { path: { company_id: companyId } },
			}),
		enabled: companyId > 0,
	})
}

export function useCompanyKyc(companyId: number) {
	return useQuery(companyKycOptions(companyId))
}
